export default "__VITE_PUBLIC_ASSET__8444df98__"